// extracted by mini-css-extract-plugin
export var button = "_c9-2";
export var iconWrapper = "_c9-0";
export var investigatingIcon = "_c9-1";